import { MappingClientT, ObjectContainerClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../../state/app.state';
import { isIosMobile, isMobile } from '../../../../../utils/app.helper';
import Polygon from '../../Polygon/Polygon';
import { getObjectClassNameFromStatus } from '../SvgMapping';

type SvgMappingViewPolygonsProps={
    lastHovered: string;
    setLastHovered: (value: string) => void;
    onObjectMouseEnter?: (object: MappingClientT) => void;
    onObjectMouseLeave?: (object: MappingClientT) => void;
    checkHoverTimer?: () => boolean;
    onObjectClick: (id: number | null) => void;
    setHoverStart: (value: Date) => void;
    disableObjectTouchInteraction: boolean
};

const SvgMappingObjectPolygons: React.FC<SvgMappingViewPolygonsProps> = ({ lastHovered, setHoverStart, setLastHovered, onObjectMouseEnter, onObjectClick, onObjectMouseLeave, checkHoverTimer, disableObjectTouchInteraction }): ReactElement => {

    const { state, presentationState } = useContext(AppContext);

    const getClassName = (mappingObject: MappingClientT, object: ObjectContainerClientT | undefined): string => {

        let className = `${(object?.statusId && `${getObjectClassNameFromStatus(state?.project?.statuses, object?.statusId)}`) || 'bv-available' }`;


        if (state?.isCurrentPreviewObject(mappingObject.mappingEntityId) && isMobile()) {
            className = className.concat(` ${getObjectClassNameFromStatus(state?.project?.statuses, object?.statusId || undefined)}--selected` || ' bv-available--selected');
        }

        if (presentationState?.activePreview && !state?.isCurrentPreviewObject(mappingObject.mappingEntityId)) {
            className = className.concat(' bv-mapping-fade');
        }

        if (!presentationState?.activePreview && !state?.isCurrentPreviewObject(mappingObject.mappingEntityId) && lastHovered !== `bv-polygon-object-${mappingObject.id}` && checkHoverTimer && checkHoverTimer()) {
            className = className.concat(' bv-mapping-fade-in');
        }

        if (state?.isCurrentPreviewObject(mappingObject.mappingEntityId)) {
            className = className.concat(' bv-pop-animation');
        }

        return className;
    };

    const onMouseEnter = (mappingObject: MappingClientT): void => {
        if (disableObjectTouchInteraction) return;
        setHoverStart(new Date());

        if (isMobile()) {
            state?.resetViewMappingPreview();
        }

        if (isIosMobile()) {
            setTimeout(() => onObjectClick(mappingObject.mappingEntityId), 1);
        }

        mappingObject.mappingEntityId && state?.setPreviewObjectId(mappingObject.mappingEntityId);

        setLastHovered(`bv-polygon-object-${mappingObject.id}`);

        presentationState?.setActivePreview(true);

        if (isMobile()) return;

        if (onObjectMouseEnter) {
            onObjectMouseEnter(mappingObject);
        }
    };

    const onMouseLeave = (mappingObject: MappingClientT): void => {
        if (disableObjectTouchInteraction) return;

        state?.setPreviewObjectId(undefined);

        if (isMobile()) {

            return;
        }
        presentationState?.setActivePreview(false);

        if (onObjectMouseLeave) {
            onObjectMouseLeave(mappingObject);
        }
    };

    const onClick = (mappingObject: MappingClientT): void => {
        if (disableObjectTouchInteraction) return;

        if (isIosMobile()) return;
        !isIosMobile() && setTimeout(() => onObjectClick(mappingObject.mappingEntityId), 1);
    };

    return useObserver(() => (
        <>
            {state?.currentViewMappingObjects?.sort((a, b) => (!state.isCurrentPreviewObject(a.mappingEntityId)) ? -1 : 1).map((mappingObject: MappingClientT) => {
                const object = state.objects?.find(obj => obj.id === mappingObject.mappingEntityId);

                return <Polygon
                    key={mappingObject.id}
                    disablePolygonTouchInteraction={disableObjectTouchInteraction}
                    id={`bv-object-polygon-${mappingObject.id}`}
                    className={getClassName(mappingObject, object)}
                    polygon={mappingObject.polycords}
                    onClick={() => onClick(mappingObject)}
                    onMouseEnter={() => onMouseEnter(mappingObject)}
                    onMouseLeave={() => onMouseLeave(mappingObject)}
                />;
            })};
        </>));
};


export default SvgMappingObjectPolygons;